import { render, staticRenderFns } from "./chat_history.vue?vue&type=template&id=89e9c8c0&scoped=true"
import script from "./chat_history.vue?vue&type=script&lang=ts"
export * from "./chat_history.vue?vue&type=script&lang=ts"
import style0 from "./chat_history.vue?vue&type=style&index=0&id=89e9c8c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e9c8c0",
  null
  
)

export default component.exports